import { useQuery, useQueryClient } from '@tanstack/react-query';
import { checkoutIntentsClient } from 'app/checkout-intents/client';
import { Return } from '@rye-com/checkout-intents-types';

const fetchReturns = async (checkoutIntentId: string): Promise<Return[]> => {
  const client = checkoutIntentsClient.get();
  if (!client) {
    throw new Error('API client not initialized');
  }

  const response = await client.get<{ data: Return[] }>(
    `/api/v1/checkout-intents/${checkoutIntentId}/returns`,
  );
  const data = response;
  return data.data;
};

export const useReturns = (checkoutIntentId: string | undefined) => {
  const queryClient = useQueryClient();

  const {
    data: returns = [],
    isLoading: loading,
    error,
  } = useQuery({
    queryKey: ['returns', checkoutIntentId],
    queryFn: () => fetchReturns(checkoutIntentId as string),
    enabled: !!checkoutIntentId,
  });

  const refetch = () => {
    queryClient.invalidateQueries({ queryKey: ['returns', checkoutIntentId] });
  };

  return {
    returns,
    loading,
    error: error as Error | null,
    refetch,
  };
};
